// Urls
import { RedirectTo } from "../../urls/PageLinksURL";

// Component
import HelpSidebar from "./HelpSidebar";
import PageHeader from "../../mavin/components/page-header/PageHeader";

// Page Constants
const videoDetailsConstants = [
  {
    label: "OTS Tool",
    videoUrl: "https://youtu.be/6UAjiy1b-VE",
    videoId: "6UAjiy1b-VE",
  },
  {
    label: "LTS Tool",
    videoUrl: "https://youtu.be/yP7JX7lyUAw",
    videoId: "yP7JX7lyUAw",
  },
  {
    label: "Site Analyzer Tool",
    videoUrl: "https://youtu.be/mWtKdK0-L30",
    videoId: "mWtKdK0-L30",
  },
  {
    label: "Route Analysis Tool",
    videoUrl: "https://youtu.be/hudkpsS9PZQ",
    videoId: "hudkpsS9PZQ",
    isHide: true, // as the above video url is not working, once we have updated url we will show this video
  },
  {
    label: "Demographics",
    videoUrl: "https://youtu.be/mYCOpGmJl58",
    videoId: "mYCOpGmJl58",
  },
  {
    label: "Road Stretches",
    videoUrl: "https://youtu.be/krRFj7ulQ6E",
    videoId: "krRFj7ulQ6E",
  },
  {
    label: "Target Group : Creation",
    videoUrl: "https://youtu.be/ajVtRAPF5aI",
    videoId: "ajVtRAPF5aI",
  },
  {
    label: "Target Group : Populate",
    videoUrl: "https://youtu.be/LnA2y9oGhqc",
    videoId: "LnA2y9oGhqc",
  },
  {
    label: "Boundaries",
    videoUrl: " https://youtu.be/6syW3HktrKE",
    videoId: "6syW3HktrKE",
  },
  {
    label: "Point Of Interest : Populate",
    videoUrl: "https://youtu.be/44tkLzD5C6Q",
    videoId: "44tkLzD5C6Q",
  },
  {
    label: "Data Layer : Create and Generation",
    videoUrl: "https://youtu.be/qJtYmhj6sno",
    videoId: "qJtYmhj6sno",
  },
  {
    label: "Monitoring Jobs : Assigning",
    videoUrl: "https://youtu.be/QGQpFB9nsT8",
    videoId: "QGQpFB9nsT8",
  },
  {
    label: "Monitoring App",
    videoUrl: "https://youtu.be/UVVxB7ZDaWM",
    videoId: "UVVxB7ZDaWM",
  },
];

// Video Cards
function VideoCardsSection() {
  return (
    <div className="row help-videos">
      {videoDetailsConstants.map((video, i) => {
        const { label = "", videoId = "", isHide = false } = video;

        if (isHide) {
          return null;
        }

        return (
          <div key={i} className="col-4">
            <div className="col px-0 card bg-alt">
              <iframe
                src={`https://www.youtube.com/embed/${videoId}?rel=0`}
                frameBorder="0"
                className="video-content"
                allow="autoplay; encrypted-media"
                allowFullScreen={true}
                title={label}
              />
            </div>
            <h4 className="mt-2">{label}</h4>
          </div>
        );
      })}
    </div>
  );
}

/**
 * Videos Help Page
 */
export default function VideosHelpPage() {
  const pageTitle = "Tutorial Videos";

  return (
    <>
      <HelpSidebar activePageUrl={RedirectTo.helpVideosPageUrl} />

      <div className="content-wrapper">
        <PageHeader title={pageTitle} shadow={true} />
        <div className="page-content">
          <VideoCardsSection />
        </div>
      </div>
    </>
  );
}
